module.exports = __webpack_public_path__ + "d1fddbbdc65e2cafb25fe3650011c335.pdf";